module.exports = __webpack_public_path__ + "static/og_image_moveme-278e1dce0ff3485f844ad2865b8cf7eb.png";